var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:(_vm.affixStyle)},[_c('div',{ref:"point",class:_vm.classes,style:(_vm.styles)},[_vm._t("default")],2),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.slot),expression:"slot"}],style:(_vm.slotStyle)})])
}
var staticRenderFns = []

export { render, staticRenderFns }